import { useWebRouter } from "~utils/next-router/use-web-router";
import { FC, ReactNode } from "react";
import { useAuthContext } from "~auth/contexts/auth";
import { useAccountAuthorization } from "~auth/hooks/use-account-authorization";
import { AuthLoadingBackdrop } from "~auth/components/auth-loading-backdrop";
import { getAccountRecoveryPath } from "~auth/helpers/get-account-recovery-path";
export const AccountGuard: FC<{ children: ReactNode }> = ({ children }) => {
	const router = useWebRouter();
	const { isLoading, isAuthenticated, authAccount } = useAuthContext();
	const { isTrialExpired, isAccountClosed } = useAccountAuthorization();

	if (isLoading) return <AuthLoadingBackdrop />;

	if (!isAuthenticated) {
		return children;
	}

	if (isTrialExpired || isAccountClosed) {
		void router.replace(
			getAccountRecoveryPath({
				accountSlug: router._query.accountName,
				isPartnerManaged: Boolean(authAccount?.partnerId),
			}),
		);
		return <AuthLoadingBackdrop />;
	}

	return children;
};
